import { RefObject, useEffect } from 'react';

type ObjectType<T> = RefObject<T | undefined | null>;

/**
 * A react hook that handles clicking outside of the referenced element.
 */
const useClickOutside = <T>(
  ref: ObjectType<T> | ObjectType<T>[],
  callback: (e: MouseEvent) => void,
): void => {
  const onClickHandler = (event: MouseEvent): void => {
    const refs = Array.isArray(ref) ? ref : [ref];
    if (
      refs.every(
        (ref) =>
          ref.current &&
          ref.current instanceof Element &&
          !ref.current.contains(event.target as Element),
      )
    ) {
      callback(event);
    }
  };

  useEffect(() => {
    document.addEventListener('click', onClickHandler);
    return () => {
      document.removeEventListener('click', onClickHandler);
    };
  });
};

export default useClickOutside;
